import { validationCNPJ } from 'components/utils/validationsFN'
import * as yup from 'yup'

export const schema = yup.object({
    uf: yup.string(),
    numeroTaxa: yup.string(),
    cnpj: yup.string(),
    cnpjAgenteFinanceiro: yup
        .string()
        .nullable()
        .test('cnpj-valido', 'CNPJ informado é inválido', value => {
            if (!value) return true
            return validationCNPJ(value)
        }),
    publica: yup.string(),
    status: yup.string()
})